import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
// import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function EvoLiveRewardsPromoFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const brandName = (brandId === 33 || brandId === 34) ? 'IW247' : (brandId === 39 || brandId === 40) ? 'Fomo7' : (brandId === 46 || brandId === 47) ? 'Fun88' : 'Yolo247';
    const totalPromotion = brandId === 61 ? '$650,000' : '₹6,50,00,000';
    const is_crypto = (brandId == 61)

    return (
        <>
            <InformationWrapper>
                <TitleConatiner>
                    <h2>Evolution Live Rewards &#45; Play Big, Get Assured Wins</h2>
                    <p>Enjoy <strong>premium live casino action</strong> on <strong>Evolution Lightning Roulette & Crazy Time</strong>.<br />Place <strong>qualifying bets</strong> and receive <strong>assured free bets</strong> as rewards.</p>
                    <GameBlock>
                        <Link to="/live-casino/evolution/live-roulette">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GameOne}`}
                                alt="Lightning Roulette"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                        <Link to="/live-casino/evolution/crazy-time">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GameTwo}`}
                                alt="Crazy Time"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                    </GameBlock>
                </TitleConatiner>
                
                <Container $isFlexDir>
                    <h2>How to Participate</h2>
                    <LeftCardWrapper>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconOne}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Play Evolution Lightning Roulette & Crazy Time</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconTwo}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Place <strong>cumulative<br /> bets of {is_crypto ? "$2,026" : "₹20,260"}</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconThree}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Receive assured<br /> free bets</strong></p>
                        </LeftCard>
                    </LeftCardWrapper>
                </Container>

                <Container>
                    <TermsImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsTermsImg}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </TermsImageWrapper>
                    <RightCradWrapper>
                        <RightCard><p>Valid from <strong>01 Jan 2026 to 28 Feb 2026</strong></p></RightCard>
                        <RightCard><p><strong>Applicable only on Evolution Lightning Roulette & Crazy Time</strong></p></RightCard>
                        <RightCard><p><strong>Free bets up to {is_crypto ? "$203" : "₹2,026"}</strong></p></RightCard>
                        <RightCard><p><strong>Claimable up to 3 times per user per week</strong></p></RightCard>
                        <RightCard><p>Bonus credited <strong>after completion of qualifying wagers</strong></p></RightCard>
                        <RightCard><p>Free bets usable  <strong>only on Evolution games</strong></p></RightCard>
                        <RightCard><p><strong>Bonus wagering requirements apply</strong></p></RightCard>
                        <RightCard><p><strong>Estimated total promotion pool: {is_crypto ? "$100,000" : "₹1,00,00,000"}</strong></p></RightCard>
                        <RightCard><p><strong>Eligible tables or games may change</strong> without prior notice</p></RightCard>
                        <RightCard><p><strong>General Live Casino terms & conditions apply</strong></p></RightCard>
                    </RightCradWrapper>
                </Container>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(EvoLiveRewardsPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;
    text-transform: capitalize;

        h2 {
            color: #06A6FF;
            text-align: center;
            font-size: 20px;
            font-style: normal;
            font-family: 'Inter-Bold';
            line-height: normal;
            text-transform: capitalize;
            margin: 0;
        }

        strong {
            font-weight: bold;
        }
`;

const TitleConatiner = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 1.5em;
    border-radius: 8px;
    text-align: center;

    p {
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const GameBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    a {
        cursor: pointer;
        width: 178px;
         img {
            max-width: 100%;
         }
    }
`;

const Container = styled.div<{ $isFlexDir?: boolean }>`
    width: 80%;
    display: flex;
    flex-direction: ${({ $isFlexDir }) => ($isFlexDir ? "column" : "row")};
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 2rem 1.5rem;
    border-radius: 8px;
`;

const LeftCardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
`;

const LeftCard = styled.div`
    width: 70%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    border-radius: 9.556px;
    border: 1px solid #989098;
    background: linear-gradient(0deg, #EBEBEB 0%, #EBEBEB 100%), rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(7.5px);
    padding: 1.5rem 2.5rem 1.5rem 2.5rem;

    img {
        width: 55px;
    }

    p {
        width: 85%;
        color: #444;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 100;
        line-height: 21px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const TermsImageWrapper = styled.div`
    flex: 0 0 45%;
    display: flex;
    text-align: right;
    justify-content: center;
    align-items: flex-start;

    img {
        width: 70%;
        align-self: flex-end;
    }
`;

const RightCradWrapper = styled.ul`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
`;

const RightCard = styled.li`
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    background: #EBEBEB;
    backdrop-filter: blur(7.5px);
    padding: 5px 25px;

    p {
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
    }
`;
